<script setup>
import { reactive, watch } from 'vue'

const props = defineProps({
    node: Object,
})

const emit = defineEmits(['update:config'])

const form = reactive({
    title: props.node?.data?.config?.title ?? '',
    body: props.node?.data?.config?.body ?? '',
    action_url: props.node?.data?.config?.action_url ?? '',
})

watch(() => props.node, (node) => {
    if (!node) return
    form.title = node.data?.config?.title ?? ''
    form.body = node.data?.config?.body ?? ''
    form.action_url = node.data?.config?.action_url ?? ''
})

function emitUpdate() {
    emit('update:config', { title: form.title, body: form.body, action_url: form.action_url })
}
</script>

<template>
    <div class="config-panel__section">
        <label class="config-panel__label">Title</label>
        <input v-model="form.title" class="config-panel__input" type="text" placeholder="Push title" @input="emitUpdate" />

        <label class="config-panel__label">Body</label>
        <textarea v-model="form.body" class="config-panel__textarea" placeholder="Push body" @input="emitUpdate" rows="3"></textarea>

        <label class="config-panel__label">Action URL</label>
        <input v-model="form.action_url" class="config-panel__input" type="url" placeholder="https://..." @input="emitUpdate" />
    </div>
</template>
